const convertCommentFromServer = (comment) => (Object.assign(Object.assign({}, comment), { is_admin_comment: comment.is_admin_comment === "1" }));
const filterNewComments = (comments, storedComments) => {
    return comments.filter((comment) => !storedComments.find((c) => c.id === comment.id));
};
export { convertCommentFromServer, filterNewComments };
